/**
 * Permission codes aligned with Operations backend (cargo, voyages, reports, consumption, CII rows).
 * Values must match backend strings (e.g. Admin bundle / effective permissions).
 */
export const OP = {
  READ_CARGO_OPERATION: 'READ_CARGO_OPERATION',
  CREATE_CARGO_OPERATION: 'CREATE_CARGO_OPERATION',
  UPDATE_CARGO_OPERATION: 'UPDATE_CARGO_OPERATION',
  DELETE_CARGO_OPERATION: 'DELETE_CARGO_OPERATION',
  APPROVE_CARGO_OPERATION: 'APPROVE_CARGO_OPERATION',
  DOWNLOAD_CARGO_OPERATION: 'DOWNLOAD_CARGO_OPERATION',

  READ_VOYAGE: 'READ_VOYAGE',
  CREATE_VOYAGE: 'CREATE_VOYAGE',
  UPDATE_VOYAGE: 'UPDATE_VOYAGE',
  DELETE_VOYAGE: 'DELETE_VOYAGE',
  DOWNLOAD_VOYAGE: 'DOWNLOAD_VOYAGE',

  /** Position Reports ({@code /operations/overview}) */
  READ_POSITION_REPORT: 'READ_POSITION_REPORT',
  CREATE_POSITION_REPORT: 'CREATE_POSITION_REPORT',
  UPDATE_POSITION_REPORT: 'UPDATE_POSITION_REPORT',
  DELETE_POSITION_REPORT: 'DELETE_POSITION_REPORT',
  DOWNLOAD_POSITION_REPORT: 'DOWNLOAD_POSITION_REPORT',

  /** Daily Progress Reports ({@code /operations/daily-progress-reports}) */
  READ_DAILY_PROGRESS_REPORT: 'READ_DAILY_PROGRESS_REPORT',
  CREATE_DAILY_PROGRESS_REPORT: 'CREATE_DAILY_PROGRESS_REPORT',
  UPDATE_DAILY_PROGRESS_REPORT: 'UPDATE_DAILY_PROGRESS_REPORT',
  DELETE_DAILY_PROGRESS_REPORT: 'DELETE_DAILY_PROGRESS_REPORT',
  DOWNLOAD_DAILY_PROGRESS_REPORT: 'DOWNLOAD_DAILY_PROGRESS_REPORT',

  /** Coastal Position Reports ({@code /operations/coastal-position-report}) */
  READ_COASTAL_POSITION_REPORT: 'READ_COASTAL_POSITION_REPORT',
  CREATE_COASTAL_POSITION_REPORT: 'CREATE_COASTAL_POSITION_REPORT',
  UPDATE_COASTAL_POSITION_REPORT: 'UPDATE_COASTAL_POSITION_REPORT',
  DELETE_COASTAL_POSITION_REPORT: 'DELETE_COASTAL_POSITION_REPORT',
  DOWNLOAD_COASTAL_POSITION_REPORT: 'DOWNLOAD_COASTAL_POSITION_REPORT',

  READ_IN_PORT_CONSUMPTION_REPORT: 'READ_IN_PORT_CONSUMPTION_REPORT',
  UPDATE_IN_PORT_CONSUMPTION_REPORT: 'UPDATE_IN_PORT_CONSUMPTION_REPORT',

  READ_CII_SUMMARY: 'READ_CII_SUMMARY',
  UPDATE_CII_VOYAGE_ROW: 'UPDATE_CII_VOYAGE_ROW',

} as const

export type OperationPermissionCode = (typeof OP)[keyof typeof OP]
